import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, BookOpen, Clock3, RotateCcw } from 'lucide-react';

const normalizeDifficulty = (difficulty) => {
  const value = String(difficulty || 'Standard').trim().toLowerCase();
  if (['easy', 'beginner'].includes(value)) return { label: difficulty || 'Easy', className: 'is-easy', time: '12 min' };
  if (['hard', 'advanced'].includes(value)) return { label: difficulty || 'Hard', className: 'is-hard', time: '30 min' };
  return { label: difficulty || 'Medium', className: 'is-medium', time: '20 min' };
};

const excerpt = (study) => {
  const content = study.objective || study.companyBackground || 'Build a structured recommendation and explain the logic behind your approach.';
  return content.length > 176 ? `${content.slice(0, 173).trim()}…` : content;
};

const CaseStudyCard = ({ study, index }) => {
  const difficulty = normalizeDifficulty(study.difficultyLevel);

  return (
    <article className="case-card" style={{ '--case-index': index }}>
      <div className="case-card-topline">
        <span className="case-card-number">{String(index + 1).padStart(2, '0')}</span>
        <span className={`case-difficulty ${difficulty.className}`}>{difficulty.label}</span>
      </div>

      <div className="case-card-body">
        <span className="case-card-area"><BookOpen size={15} /> {study.area || 'Consulting case'}</span>
        <h2>{study.title || 'Untitled case study'}</h2>
        <p>{excerpt(study)}</p>
      </div>

      <div className="case-card-footer">
        <span><Clock3 size={15} /> {difficulty.time} estimate</span>
        <Link to={`/case/${study._id}`} className="case-card-action">
          Start case <ArrowUpRight size={18} />
        </Link>
      </div>
    </article>
  );
};

const CaseStudyGrid = ({ caseStudies = [], onReset }) => {
  if (!caseStudies.length) {
    return (
      <section className="case-library-state is-empty">
        <span>0 matches</span>
        <h2>No cases fit those filters.</h2>
        <p>Clear the current filters to return to the complete case library.</p>
        {onReset && (
          <button type="button" onClick={onReset}><RotateCcw size={16} /> Clear filters</button>
        )}
      </section>
    );
  }

  return (
    <div className="case-card-grid">
      {caseStudies.map((study, index) => (
        <CaseStudyCard key={study._id} study={study} index={index} />
      ))}
    </div>
  );
};

export default CaseStudyGrid;
